<svg height="100%" width="100%" viewBox="0 0 5 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.0290474 0.599609H3.51953V17.4004H0.0290474" stroke="white" />
</svg>
